/* eslint-disable react/style-prop-object */
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { BaseCss } from 'blocket-ui'
import staticFilesUrl from 'utils/staticFilesUrl'
import loadScript from './loadScript'

const staticFilesUrlWithOutTrailingSlash = staticFilesUrl.replace(/\/$/, '')

const createNewEvent = (eventName) => {
  let event
  if (typeof Event === 'function') {
    event = new Event(eventName)
  } else {
    event = document.createEvent('Event')
    event.initEvent(eventName, true, true)
  }
  return event
}

export const Head = React.memo(() => {
  const title = 'Blocket - Sveriges största marknadsplats, bilar, bostäder, möbler m.m.'

  loadScript(`${staticFilesUrl}assets/scripts/ast.js`, { async: true }, (err) => {
    if (err) {
      /* eslint-disable no-console */
      console.error(`appnexus script loading failed with ${err}`)
    } else {
      const apnLoadedEvent = createNewEvent('apnLoaded')
      setTimeout(document.dispatchEvent(apnLoadedEvent), 0)
    }
  })

  return (
    <React.Fragment>
      <Helmet>
        <html lang="sv" style="display: flex; width: 100%; -webkit-text-size-adjust: 100%;" />

        <script>window.dataLayer = window.dataLayer || [];</script>
        <script src={`${staticFilesUrl}assets/scripts/afsh.js`} type="text/javascript"></script>

        <body style="width: 100%;" />
        <title>{title}</title>
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:image" content={`${staticFilesUrl}assets/images/blocketLogotype.png`} />

        <link rel="icon" href={`${staticFilesUrl}assets/favicon/favicon-64.png`} sizes="64x64" />
        <link rel="icon" href={`${staticFilesUrl}assets/favicon/favicon-128.png`} sizes="128x128" />
        <link rel="icon" href={`${staticFilesUrl}assets/favicon/favicon-196.png`} sizes="196x196" />
        <link rel="icon" href={`${staticFilesUrl}assets/favicon/favicon.png`} />
        <link rel="icon" href={`${staticFilesUrl}assets/favicon/favicon-16.png`} sizes="16x16" />
        <link rel="icon" href={`${staticFilesUrl}assets/favicon/favicon-32.png`} sizes="32x32" />

        <link
          rel="apple-touch-icon"
          href={`${staticFilesUrl}assets/favicon/apple-touch-icon-152.png`}
        />
      </Helmet>

      <BaseCss publicPath={`${staticFilesUrlWithOutTrailingSlash}`} />
    </React.Fragment>
  )
})

export default Head
